<template>
  <div class="about">
    <Topmenu />
    <div class="subbanner pr">
      <img src="@/assets/bannerabout.jpg" />
    </div>
    <div class="wrapcon">
      <div class="wrapLeft">
        <h4 class="current">您的位置：<a href="index.html">首页 </a> &gt;<a href="aboutus.html">关于我们</a></h4>
        <div class="intro">
          <h4 id="gongsijianjie" class="smalltit">公司介绍</h4>

          <p style="padding-right: 50px">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;精诚为医（北京）技术有限公司，专注于医院绩效管理，汇聚了国内顶级的医院管理专家以及众多实战经验丰富的管理咨询师，为医院提供<span
              style="font-weight: bold"
              >绩效管理、预算成本管理、战略制定、科室建设规划和竞争力分析</span
            >等管理咨询服务。<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;精诚为医，采用以工作量为核心，以预算为导向，辅以质量控制、成本控制、医德医风和患者满意度等因素，针对医、护、技、药、管等不同岗位，形成一套完善的绩效考核与绩效工资核算体系，充分体现多劳多得、优绩优酬的分配思想，全面推动医院各项管理工作的信息化、规范化，助力医院走向精细化管理的飞速发展之路！
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span style="font-weight: bold">精诚为医，精于业 诚于心！</span>
          </p>
          <h4 id="qiyeweihuan" class="smalltit">企业文化</h4>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;诚信、合作、进取、创新</p>
          <h4 id="qiyeweihuan" class="smalltit">企业理念</h4>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为客户提供最佳服务</p>

          <!-- <h4 id="zuzhijiagou" class="smalltit">组织架构</h4>
          <img src="@/assets/zjjg.png" /> -->
          <h4 id="gongsizizhi" class="smalltit">联系我们</h4>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：18931158707</p>
          <!-- <div class="twocode">
            <div class="code code01">
              <img src="@/assets/weixingongzhonghao.jpg" />
              <span>微信公众号</span>
            </div>
            <div class="code code01">
              <img src="@/assets/zhuanjia.jpg" />
              <span>咨询专家</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="wrapRight">
        <div class="submenu">
          <img src="@/assets/submenu05.png" />
          <div class="sublink">
            <a href="#gongsijianjie">公司介绍</a>
            <a href="#qiyeweihuan">企业文化</a>
            <a href="#zuzhijiagou">企业理念</a>
            <a href="#gongsizizhi">联系我们</a>
          </div>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>
<script>
import Topmenu from '@/components/topmenu'
import Bottom from '@/components/bottom'
export default {
  name: 'About',
  components: {
    Topmenu,
    Bottom
  },
  data() {
    return {}
  },
  created() {
    this.$nextTick(() => this.getLocal())
  },
  destroyed() {
    localStorage.setItem('anchorId', '')
  },
  methods: {
    getLocal() {
      let select = localStorage.getItem('anchorId')
      let ele = document.getElementById(select)

      if (select) {
        ele.scrollIntoView(true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapcon {
  width: 1200px;
  margin: 10px auto;
  overflow: hidden;
  padding-bottom: 30px;
}
.submenu {
  width: 239px;
}
.submenu img {
  display: block;
}
.sublink {
  background: #fafafa;
}
.sublink a {
  display: block;
  text-align: center;
  height: 45px;
  line-height: 45px;
}
.sublink a.on {
  /*background: url(../images/linkjt.png) no-repeat 15px center; */
  font-size: 18px;
  color: #d2000f;
}
.sublink a:hover {
  color: #d2000f;
}
.wrapLeft {
  width: 900px;
  float: right;
}
.wrapLeft h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
.wrapLeft h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url('~@/assets/ico01.png') no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
  text-align: justify;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}

.twocode {
  width: 300px;
  margin-left: 20px;
  margin-top: 10px;
}
.code {
  width: 120px;
  float: left;
  margin-left: 20px;
  float: left;
  text-align: center;
}
.code img {
  width: 120px;
  border: 1px solid #e0e0e0;
}
.code span {
  display: block;
  text-align: center;
  padding-top: 3px;
}
</style>
